import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { navigate } from 'gatsby';
import Link from '../layouts/Link';

export default function HomeMobileActivitiesCards({ data }) {
  const [clicked, setClicked] = React.useState(null);
  const toggle = (index) => {
    if (clicked === index) {
      return setClicked(null);
    }
    setClicked(index);
  };
  return (
    <div className="md:hidden flex flex-col overflow-hidden">
      {isEmpty(data) ||
        data.map((item, index) => (
          <div
            className="relative h-[300px] before:!inline before:content-['']
          before:absolute before:top-0 before:w-full before:h-full before:bg-black
          before:bg-opacity-50 group overflow-hidden"
            key={index}
          >
            {isEmpty(item.content.mobileImage) || (
              <LazyLoadImage
                src={item.content.mobileImage.url}
                className="w-full h-full object-cover object-top"
              />
            )}
            <div
              className="absolute top-0 w-full h-full px-6 flex flex-col justify-center items-center
              gap-y-5"
            >
              <button
                type="button"
                onClick={() => {
                  if (isEmpty(item.content.links)) {
                    const url = item.content.buttons[0].url.replace('dsw-new/', '');
                    navigate(url);
                  } else toggle(index);
                }}
                className="text-white uppercase font-roboto-condensed-bold text-[50px]
                leading-[1.2]"
              >
                {isEmpty(item.content.links) && console.log(item.content)}
                {item.content.title}
              </button>
              {clicked !== index || (
                <div className="flex flex-wrap justify-evenly gap-y-4 gap-x-3">
                  {isEmpty(item.content.links) ||
                    item.content.links.map((itemLinks, index2) => (
                      <Link
                        to={itemLinks.url}
                        key={index2}
                        className="text-[16px] leading-6 text-white font-roboto-bold min-w-[71px]"
                      >
                        {itemLinks.name}
                      </Link>
                    ))}
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
